import type { ReactNode } from 'react';
import { go } from '../lib/route';

interface Props {
  /** Shown to the left of the rule. Defaults to the product name. */
  readonly title?: string;
  readonly who?: string | undefined;
  readonly onSignOut?: (() => void) | undefined;
  /** A crumb back to wherever this page hangs off. */
  readonly back?: { readonly label: string; readonly to: string } | undefined;
  readonly children: ReactNode;
}

export const Shell = ({ title = 'Mantelpiece', who, onSignOut, back, children }: Props) => (
  <main className="shell">
    <header className="masthead">
      <p className="masthead-id">{title}</p>
      <p className="masthead-who">
        {who && (
          <>
            <button type="button" className="tab" onClick={() => go('/account')} style={{ padding: 0 }}>
              {who}
            </button>
            {onSignOut ? ' · ' : ''}
          </>
        )}
        {onSignOut && (
          <button type="button" className="tab" onClick={onSignOut} style={{ padding: 0 }}>
            Sign out
          </button>
        )}
      </p>
    </header>

    {back && (
      <p className="crumb">
        <button type="button" className="linky" onClick={() => go(back.to)}>
          ← {back.label}
        </button>
      </p>
    )}

    {children}
  </main>
);
